// extracted by mini-css-extract-plugin
module.exports = {"cta":"CtaStyle_cta__193IL","ctaTitle":"CtaStyle_ctaTitle__1g-u9","ctaDesc":"CtaStyle_ctaDesc__383ws"};